<script>
    import { Datetime } from 'vue-datetime'
    import 'vue-datetime/dist/vue-datetime.css'

    export default {
        components : {
            Datetime,
        },
        data() {
            return Object.assign({}, {
                locale: window.locale,
                url : '',
                upload_url : '',
                url_code : 'dummy',
                agree : false,
                step : 1,
                filled_step: 1,
                validating_step : '',
                id : '',
                applying_class : '',
                priority_one : '',
                priority_two : '',
                priority_three : '',
                expected_entry_date : '',
                en_last_name : '',
                en_first_name : '',
                other_first_name : '',
                other_last_name : '',
                date_of_birth : '',
                gender : '',
                place_of_birth: '',
                religion: '',
                identity_no: '',
                post_number: '',
                phone: '',
                email: '',
                age : '',
                common_lang: '',
                nationality: '',
                baptized_date: '',
                address: '',
                district: '',
                previous_school: '',
                father_other_last_name : '',
                father_other_first_name : '',
                father_en_last_name : '',
                father_en_first_name : '',
                father_company : '',
                father_company_phone : '',
                father_address: '',
                father_occupation: '',
                father_phone: '',
                father_email: '',
                father_education: '',
                father_relationship: 'father',
                father_guardian_relationship: '',
                father_live_together: 'Y',

                mother_other_last_name : '',
                mother_other_first_name : '',
                mother_en_last_name : '',
                mother_en_first_name : '',
                mother_company_phone : '',
                mother_company : '',
                mother_address: '',
                mother_occupation: '',
                mother_phone: '',
                mother_email: '',
                mother_education: '',
                mother_relationship: 'mother',
                mother_guardian_relationship: '',
                mother_live_together: 'Y',

                main_contact_person: 'father',
                how_to_know: '',
                alternative_session : '',
                previous_schooling_record: [],
                relative_record : [],
                related_school_record : [],
                other_remarks: '',
                upload_files : {},
                validation_scope : {
                    1 : 'class-info',
                    2 : 'student-info',
                },
                files : [],
                uploaded : [],
                application_no : '',
                url_code : '',
                interview_date : '',
                allow_parent_update_interview_slot : '',
                allow_update_form : '',
                admission_fee_paid : false,
                from : '',
                to: '',
                fully_booked : false,
                admission_fee : 0,
                validation_msg: '',
                existing_documents : {},
                checking_document_count : {},
                document_to_remove : [],
                applicant_data : null,
                form_from : null,
                birthCertTimeout: null,
                birthDateTimeout: null,
                identity_no_exist: false,
                birth_date_invalid: false,
                expired_time: '',
                expired_time_for_countdown:'',
                expired_time_notification: '',
                expired_notification_popup_timer: '',
                expired_reload_func: '',
                expired_notification_func: '',
                notififcation_modal: false,
                currentTime: null,
                pay_at_school: false,
                pay_at_school_mail_template_id: '',
                sections_length: 1,
                priority_rank_counts: {},
            }, __FORM__);
        },
        props: {

        },
        methods: {
            validate()
            {
                let self = this;
                let scope = this.validation_scope[this.step];
                this.$validator.validateAll(scope).then((result) => {
                    if (result && !this.identity_no_exist && !this.birth_date_invalid) {
                        this.move_step('add');
                    }else{
                        setTimeout(
                        function() {
                            if(_.first(self.errors.items).field=='address'){
                                $('textarea[name="' + _.first(self.errors.items).field + '"]').focus();
                            }else if(_.first(self.errors.items).field=='place_of_birth' || _.first(self.errors.items).field=='nationality' || _.first(self.errors.items).field=='district'){
                                $('select[name="' + _.first(self.errors.items).field + '"]').focus();
                            }else if(_.first(self.errors.items).field=='gender'){
                                $([document.documentElement, document.body]).animate({
                                    scrollTop: $("#input-gender").offset().top - 70
                                }, 0);
                            }else{
                                $('input[name="' + _.first(self.errors.items).field + '"]').focus();
                            }
                        }, 500);
                    }
                });
            },
            to_form () {
                window.location.href = '/admission/form';
            },
            to_form_update () {
                window.location.href = '/admission/form-update';
            },
            to_index() {
                window.location.href = '/admission';
            },
            clickExistConfirm() {
                this.is_exist = false;
                window.location.href = '/admission/form-update';
            },
            step_class(current_step) {
                if(this.step == current_step) {
                    return 'step clickable step-current';
                } else if(this.step > current_step) {
                    return 'step clickable step-past';
                }
                return 'step';
            },
            move_step(direction) {
                if(direction == 'add') {
                    this.step++;
                }

                if(direction == 'subtract') {
                    if(this.step > 1) {
                        this.step--;
                    }
                }

                window.scrollTo(0,0);
            },
            move_to_step(step) {
                if(this.step == 7) {
                    return false;
                }
                if(this.step == 6 && step < 6) {
                    return false;
                }
                if(step <= this.filled_step) {
                    this.step = step;
                }
            },
            addSibling()
            {
                this.relative_record.push(
                    {
                        en_first_name: '',
                        en_last_name: '',
                        other_first_name: '',
                        other_last_name: '',
                        relationship: '',
                        school_year: '',
                        class: '',
                        remarks: '',
                    }
                );
            },
            addRelatedSchool()
            {
                this.related_school_record.push(
                    {
                        en_first_name: '',
                        en_last_name: '',
                        other_first_name: '',
                        other_last_name: '',
                        relationship: '',
                        school: '',
                        school_year: '',
                        class: '',
                        remarks: '',
                    }
                )
            },
            getFileName(event, id) {
                let files = event.target.files;

                if(!this.upload_files[id]) {
                    this.$set(this.upload_files, id, []);
                }

                _.each(files, (item, key) => {
                    this.upload_files[id].push(item['name']);
                    let data = {
                        type_id : id,
                        name : item['name'],
                        file : item,
                    };
                    this.checking_document_count[id] = data;
                    this.files.push(data);
                })

                _.each(files, (item, key) => {
                    let data = {
                        type_id : id,
                        name : item['name'],
                        file : item,
                    };
                    this.checking_document_count[id] = data;
                })

            },
            removeUploadedFile(elm_id, field, validation_field, key) {
                let file_name = this.upload_files[field][key];
                let file_index = _.findIndex(this.files, (file) => {
                    return file.type_id == field && file.name == file_name;
                });

                this.upload_files[field].splice(key, 1);
                if(file_index !== -1) {
                    this.files.splice(file_index, 1);
                }

                this.$delete(this.checking_document_count, field);
                document.getElementById(elm_id).value = '';
                this.$nextTick(() => this.$validator.validate(validation_field));
            },
            removeExistFile(document_id, document_type, key)
            {
                this.existing_documents[document_type].splice(key, 1);
                this.document_to_remove.push(document_id);
                this.$nextTick(() => this.$validator.validate(document_type));
            },
            submitDocument() {
                let url = this.upload_url;
                let self = this;
                let formData = new FormData;

                if(this.files.length > 0) {
                    this.uploaded.push(this.uploading_files[0]);

                } else {
                    this.openPageAfterConfirmation();
                    return true;
                }

                formData.append('file', this.files[0]['file']);
                formData.append('file_type', this.files[0]['type_id']);
                formData.append('url_code', this.url_code);
                this.files.splice(0, 1);


                let ajaxSuccessCallback = (response) => {
                    self.$nextTick(function() {
                        self.$store.commit('setRedirectNotification', response.data.msg);
                        self.$store.commit('setNotificationType', 'success');

                        this.submitDocument();
                    });
                };

                let ajaxFailCallback = (error) => {
                    if (error.response.status == '422') {
                        let system_error = error.response.data.errors;
                        let errors = {};
                        let self = this;
                        Object.keys(system_error).forEach(function(key){
                            errors[key] = system_error[key];
                        })

                        self.$store.commit('setValidationError', errors);
                    } else {
                        self.$store.commit('setError', (typeof error.response.data.msg != 'undefined' ? error.response.data.msg : 'Failure'));
                    }
                };
                self.$store.commit('clearValidationError');
                self.$store.commit('clearError');

                self.$root.ajax_post(url, formData, ajaxSuccessCallback, ajaxFailCallback, true, {headers: {'Content-Type': 'multipart/form-data' }});
            },
            getFormData() {
                let formData = new FormData;
                if(this.id != '') {
                    formData.append('id', this.id);
                }
                if(this.year_id) {
                    formData.append('year_id', this.year_id);
                }
                formData.append('applying_class', this.applying_class);
                formData.append('priority_one', this.priority_one);
                formData.append('priority_two', this.priority_two);
                formData.append('priority_three', this.priority_three);
                formData.append('en_last_name', this.en_last_name);
                formData.append('en_first_name', this.en_first_name);
                formData.append('other_first_name', this.other_first_name);
                formData.append('other_last_name', this.other_last_name);
                formData.append('date_of_birth', this.date_of_birth ? this.date_of_birth.substr(0, 10) : '');
                formData.append('gender', this.gender);
                formData.append('place_of_birth', this.place_of_birth);
                formData.append('religion', this.religion);
                formData.append('identity_no', this.identity_no);
                formData.append('post_number', this.post_number);
                formData.append('phone', this.phone);
                formData.append('email', this.email);
                formData.append('age', this.age);
                formData.append('common_lang', this.common_lang);
                formData.append('nationality', this.nationality);
                formData.append('baptized_date',this.baptized_date ? this.baptized_date.substr(0, 10) : '');
                formData.append('address', this.address);
                formData.append('district', this.district);
                formData.append('previous_school', this.previous_school);
                formData.append('father_en_first_name', this.father_en_first_name);
                formData.append('father_en_last_name', this.father_en_last_name);
                formData.append('father_other_first_name', this.father_other_first_name);
                formData.append('father_other_last_name', this.father_other_last_name);
                formData.append('father_company', this.father_company);
                formData.append('father_company_phone', this.father_company_phone);
                formData.append('father_address', this.father_address);
                formData.append('father_occupation', this.father_occupation);
                formData.append('father_phone', this.father_phone);
                formData.append('father_email', this.father_email);
                formData.append('father_relationship', this.father_relationship);
                formData.append('father_guardian_relationship', this.father_guardian_relationship);
                formData.append('father_education', this.father_education);
                formData.append('mother_en_first_name', this.mother_en_first_name);
                formData.append('mother_other_first_name', this.mother_other_first_name);
                formData.append('mother_en_last_name', this.mother_en_last_name);
                formData.append('mother_other_last_name', this.mother_other_last_name);
                formData.append('mother_company', this.mother_company);
                formData.append('mother_company_phone', this.mother_company_phone);
                formData.append('mother_address', this.mother_address);
                formData.append('mother_occupation', this.mother_occupation);
                formData.append('mother_phone', this.mother_phone);
                formData.append('mother_email', this.mother_email);
                formData.append('mother_education', this.mother_education);
                formData.append('mother_relationship', this.mother_relationship);
                formData.append('mother_guardian_relationship', this.mother_guardian_relationship);
                formData.append('main_contact_person', this.main_contact_person);
                formData.append('alternative_session', this.alternative_session);
                formData.append('previous_schooling_record', this.previous_schooling_record);
                formData.append('how_to_know', this.how_to_know ? this.how_to_know : '');
                formData.append('other_remarks', this.other_remarks ? this.other_remarks : '');
                _.each(this.relative_record, (item, key) => {
                    _.each(item, (i, k) => {
                        formData.append('relative_record[' + key + '][' + k + ']', i);
                    })
                })
                _.each(this.related_school_record, (item, key) => {
                    _.each(item, (i, k) => {
                        formData.append('related_school_record[' + key + '][' + k + ']', i);
                    })
                })
                //
                // if (!_.isUndefined(document.getElementById('btnUploadCert').files)) {
                //     formData.append('cert_files', document.getElementById('btnUploadCert').files);
                // }

                _.each(this.document_to_remove , (item, key) => {
                    formData.append('document_to_remove[]', item);
                });

                return formData;
            },
            cloneObject(source_object) {
                return JSON.parse(JSON.stringify(source_object));
            },
            getOpeningInterviews()
            {
                let self = this;

                let ajaxSuccessCallback = (response) => {
                    self.$nextTick(function() {
                        self.$store.commit('setRedirectNotification', response.data.msg);
                        self.$store.commit('setNotificationType', 'success');
                        self.levels = response.data.levels;
                        self.sections = response.data.sections;
                        self.level_sections = response.data.level_sections;
                        self.priority_rank_counts = response.data.priority_rank_counts || {};
                        if(self.applying_class && self.priority_rank_counts[self.applying_class] != null){
                            self.sections_length = self.priority_rank_counts[self.applying_class];
                        }

                        if(this.applicant_data) {
                            this.applying_class = this.applicant_data.applying_class;
                            this.priority_one = this.applicant_data.priority_one;
                            this.priority_two = this.applicant_data.priority_two;
                            this.priority_three = this.applicant_data.priority_three;
                        }
                    });
                };

                let ajaxFailCallback = (error) => {};

                let url =  this.opening_interview_url.replace('__ID__', this.year_id);

                this.$root.ajax_get(url, ajaxSuccessCallback, ajaxFailCallback, true);
            },
            submit() {
                let url = this.url;
                let self = this;

                let ajaxSuccessCallback = (response) => {
                    self.$nextTick(function() {
                        self.$store.commit('setRedirectNotification', response.data.msg);
                        self.$store.commit('setNotificationType', 'success');
                        self.url_code = response.data.msg.url_code;
                        self.application_no = response.data.msg.application_no;
                        self.interview_date = response.data.msg.interview_date;
                        self.from = response.data.msg.from;
                        self.to = response.data.msg.to;
                        self.allow_parent_update_interview_slot = response.data.msg.allow_parent_update_interview_slot;
                        self.allow_update_form = response.data.msg.allow_update_form;
                        self.pay_at_school_mail_template_id = response.data.msg.pay_at_school_mail_template_id;
                        self.admission_fee_paid = !!response.data.msg.admission_fee_paid;
                        if (this.files.length > 0) {
                            this.submitDocument();
                            self.step = 5;
                        } else {
                            this.openPageAfterConfirmation();
                        }
                        // location.href = self.redirect_url;
                    });
                };

                let ajaxFailCallback = (error) => {
                    if (error.response.status == '422') {
                        let system_error = error.response.data.errors;
                        let errors = {};
                        let self = this;
                        Object.keys(system_error).forEach(function(key){
                            errors[key] = system_error[key];
                            if(key=='identity_no') {
                                self.is_exist = true;
                            }
                        })
                        self.$store.commit('setValidationError', errors);

                    } else if (error.response.status == '400') {
                        let system_error = error.response.data.errors;
                        this.fully_booked = true;

                        this.getOpeningInterviews();
                        self.step = 1;
                    } else {
                        self.$store.commit('setError', (typeof error.response.data.msg != 'undefined' ? error.response.data.msg : 'Failure'));
                    }
                };
                self.$store.commit('clearValidationError');
                self.$store.commit('clearError');

                let formData = this.getFormData();

                self.$root.ajax_post(url, formData, ajaxSuccessCallback, ajaxFailCallback, true, {headers: {'Content-Type': 'multipart/form-data' }});
            },
            openPageAfterConfirmation() {
                if (this.admission_fee_paid) {
                    this.pay_at_school = false;
                    this.step = 7;
                    return;
                }
                this.step = 6;
            },
            removeRelative(index)
            {
                this.relative_record.splice(index, 1);
            },
            removeRelatedSchool(index)
            {
                this.related_school_record.splice(index, 1);
            },
            printPdf()
            {
                window.open('/admission/pdf/' + this.url_code);
            },
            paidAtSchool()
            {
                let self = this;
                let url = '/admission/pay-at-school';
                let formData = new FormData;
                if(this.id != '') {
                    formData.append('id', self.id);
                }
                formData.append('url_code', self.url_code);
                formData.append('mail_template_id', self.pay_at_school_mail_template_id);

                let ajaxSuccessCallback = (response) => {
                    self.$nextTick(function() {
                        self.$store.commit('setRedirectNotification', response.data.msg);
                        self.$store.commit('setNotificationType', 'success');
                        self.pay_at_school = true;
                        self.step++;
                    });
                };

                let ajaxFailCallback = (error) => {
                    if (error.response.status == '422') {
                        let system_error = error.response.data.errors;
                        let errors = {};
                        let self = this;
                        Object.keys(system_error).forEach(function(key){
                            errors[key] = system_error[key];
                        })

                        self.$store.commit('setValidationError', errors);
                    } else {
                        self.$store.commit('setError', (typeof error.response.data.msg != 'undefined' ? error.response.data.msg : 'Failure'));
                    }
                };
                self.$store.commit('clearValidationError');
                self.$store.commit('clearError');

                self.$root.ajax_post(url, formData, ajaxSuccessCallback, ajaxFailCallback, true, {headers: {'Content-Type': 'multipart/form-data' }});

                // this.pay_at_school = true;
                // this.step++;
            },
            paidByAlipay()
            {
                this.pay_at_school = false;
                window.open('','gateway','width=1000,height=900');
                $('#payment_submit_form').submit();
            },
            getLoginFormData() {
                let formData = new FormData;

                formData.append('application_no', this.application_no);
                formData.append('identity_no', this.identity_no);
                formData.append('email', this.email);
                formData.append('form_from', this.form_from);

                return formData;
            },
            getApplicationForm()
            {
                let self = this;
                let url = this.get_applicant_url;
                let formData = this.getLoginFormData();

                let ajaxSuccessCallback = (response) => {
                    self.$nextTick(function() {
                        self.$store.commit('setRedirectNotification', response.data.msg);
                        self.$store.commit('setNotificationType', 'success');
                        // self.interviews = response.data.msg;
                        this.applicant_data = {};
                        //get Applicant Data
                        this.applicant_data = response.data.data;
                        this.year_id = response.data.data.year_id;

                        self.assignData(this.applicant_data);
                        self.step++;

                    });
                };

                let ajaxFailCallback = (error) => {
                    if (error.response.status == '422') {
                        let system_error = error.response.data.errors;
                        let errors = {};
                        let self = this;
                        Object.keys(system_error).forEach(function(key){
                            errors[key] = system_error[key];
                        })

                        self.$store.commit('setValidationError', errors);
                    } else {
                        self.$store.commit('setError', (typeof error.response.data.msg != 'undefined' ? error.response.data.msg : 'Failure'));
                    }
                };
                self.$store.commit('clearValidationError');
                self.$store.commit('clearError');

                self.$root.ajax_post(url, formData, ajaxSuccessCallback, ajaxFailCallback, true, {headers: {'Content-Type': 'multipart/form-data' }});
            },
            loginForm()
            {
                let self = this;
                let formData = null;
                let ajaxSuccessCallback = null;
                let ajaxFailCallback = null;

                let url = this.login_url;
                formData = this.getLoginFormData();

                ajaxSuccessCallback = (response) => {
                    self.$nextTick(function() {
                        self.$store.commit('setRedirectNotification', response.data.msg);
                        self.$store.commit('setNotificationType', 'success');

                        this.getApplicationForm();

                    });
                };

                ajaxFailCallback = (error) => {
                    if (error.response.status == '422') {
                        let system_error = error.response;
                        let errors = {};
                        let self = this;

                        self.validation_msg = system_error.data.msg;
                        self.not_valid = true;
                    }
                };

                self.$store.commit('clearValidationError');
                self.$store.commit('clearError');


                self.$root.ajax_post(url, formData, ajaxSuccessCallback, ajaxFailCallback, true, {headers: {'Content-Type': 'multipart/form-data' }});

            },
            assignData(data) {
                this.year_id = data.year_id;
                this.id = data.id;
                this.address = data.address;
                this.application_no = data.application_no;
                this.applying_class = data.applying_class;
                this.baptized_date = data.baptized_date;
                this.birth_document = data.birth_document;
                this.common_lang = data.common_lang;
                this.date_of_birth = data.date_of_birth;
                this.district = data.district;
                this.email = data.email;
                this.en_first_name = data.en_first_name;
                this.en_last_name = data.en_last_name;
                this.en_parent_name = data.en_parent_name;
                this.expected_entry_date = data.expected_entry_date;
                this.gender = data.gender;
                this.identity_no = data.identity_no;
                this.nationality = data.nationality;
                this.other_first_name = data.other_first_name;
                this.other_last_name = data.other_last_name;
                this.other_parent_name = data.other_parent_name;
                this.phone = data.phone;
                this.place_of_birth = data.place_of_birth;
                this.post_number = data.post_number;
                this.previous_school = data.previous_school;
                this.priority_one = data.priority_one;
                this.priority_three = data.priority_three;
                this.priority_two = data.priority_two;
                this.religion = data.religion;
                this.remarks = data.remarks;
                this.url_code = data.url_code;
                this.how_to_know = data.how_to_know;
                this.other_remarks = data.other_remarks;

                this.father_other_last_name = data.father_other_last_name || '';
                this.father_other_first_name = data.father_other_first_name || '';
                this.father_en_last_name = data.father_en_last_name || '';
                this.father_en_first_name = data.father_en_first_name || '';
                this.father_company = data.father_company || '';
                this.father_company_phone = data.father_company_phone || '';
                this.father_address = data.father_address || '';
                this.father_occupation = data.father_occupation || '';
                this.father_phone = data.father_phone || '';
                this.father_email = data.father_email || '';
                this.father_education = data.father_education || '';
                this.father_relationship = data.father_relationship || 'father';
                this.father_guardian_relationship = data.father_guardian_relationship || '';

                this.father_live_together = data.father_live_together || '';
                this.mother_other_last_name = data.mother_other_last_name || '';
                this.mother_other_first_name = data.mother_other_first_name || '';
                this.mother_en_last_name = data.mother_en_last_name || '';
                this.mother_en_first_name = data.mother_en_first_name || '';
                this.mother_company_phone = data.mother_company_phone || '';
                this.mother_company = data.mother_company || '';
                this.mother_address = data.mother_address || '';
                this.mother_occupation = data.mother_occupation || '';
                this.mother_phone = data.mother_phone || '';
                this.mother_email = data.mother_email || '';
                this.mother_education = data.mother_education || '';
                this.mother_relationship = data.mother_relationship || 'mother';
                this.mother_guardian_relationship = data.mother_guardian_relationship || '';
                this.main_contact_person = data.main_contact_person || 'father';
                this.relative_record = data.relative_record;
                this.related_school_record =data.related_school_record;
                this.existing_documents = data.documents;
            },
            checkBirthCert(){

                let self = this;
                let ajaxSuccessCallback = null;
                let ajaxFailCallback = null;
                let url = '/admission/check-birth-cert';
                let formData = new FormData;

                formData.append('identity_no', this.identity_no);
                formData.append('year_id', this.year_id);

                ajaxSuccessCallback = (response) => {
                    if(!response.data.status){
                        self.identity_no_exist = true;
                    }else{
                        self.identity_no_exist = false
                    }
                };

                ajaxFailCallback = (error) => {
                    if (error.response.status == '422') {
                    }
                };

                self.$root.ajax_post(url, formData, ajaxSuccessCallback, ajaxFailCallback, true, {headers: {'Content-Type': 'multipart/form-data' }});

            },
            checkBirthDate(){

                let self = this;
                let ajaxSuccessCallback = null;
                let ajaxFailCallback = null;
                let url = '/admission/check-birth-date-valid';
                let formData = new FormData;

                formData.append('date_of_birth', this.date_of_birth);
                formData.append('applying_class', this.applying_class);
                formData.append('year_id', this.year_id);

                ajaxSuccessCallback = (response) => {
                    if(!response.data.status){
                        self.birth_date_invalid = true;
                    }else{
                        self.birth_date_invalid = false
                    }
                };

                ajaxFailCallback = (error) => {
                };

                self.$root.ajax_post(url, formData, ajaxSuccessCallback, ajaxFailCallback, true, {headers: {'Content-Type': 'multipart/form-data' }});

            },
            ReActiveDialog() {
                this.notififcation_modal = true;
            },
            confirmReActive() {
                let self = this;
                let ajaxSuccessCallback = null;
                let ajaxFailCallback = null;
                let url = '/admission/re-active';

                this.notififcation_modal = false;

                ajaxSuccessCallback = (response) => {
                    clearTimeout(self.expired_reload_func);
                    self.expired_notification_func = setTimeout(self.ReActiveDialog, self.expired_notification_popup_timer); // mins x 1000
                    self.expired_reload_func = setTimeout(self.to_index, self.expired_time * 60 * 1000); // mins x 1000
                    self.expired_time_for_countdown = self.expired_time * 60 * 1000;
                };
                ajaxFailCallback = (error) => {
                };

                self.$root.ajax_call(url, 'get', '', ajaxSuccessCallback, ajaxFailCallback, true);

            },
            RejectReActive() {
                this.to_index();
            },
            countdown() {
                this.expired_time_for_countdown -= 1000;
                let t = this.expired_time_for_countdown;
                let seconds = Math.floor((t / 1000) % 60);
                let minutes = Math.floor((t / 1000 / 60) % 60);
                let hours = Math.floor((t / (1000 * 60 * 60)) % 24);
                let days = Math.floor(t / (1000 * 60 * 60 * 24));
                if(days>0){
                    hours += days*24;
                }
                if(hours>0){
                    minutes += hours*60;
                }
                if (t > 0) {
                    this.currentTime = {
                        total: t,
                        minutes: minutes,
                        seconds: seconds
                    };
                    setTimeout(this.countdown, 1000);
                } else {
                    this.currentTime = null;
                }
            },
            parentRule(parent) {
                if(!this.father_en_first_name && !this.father_en_last_name && !this.father_phone
                && !this.mother_en_first_name && !this.mother_en_last_name && !this.mother_phone
                ){
                    return 'required';
                }else if(parent=='father' && (this.father_en_first_name || this.father_en_last_name || this.father_phone)){
                    return 'required';
                }else if(parent=='mother' && (this.mother_en_first_name || this.mother_en_last_name || this.mother_phone)){
                    return 'required';
                }else{
                    return '';
                }
            },
            relationshipRule(identity) {
                let val = '';

                switch (identity){
                    case 'father':
                        if(this.father_relationship == 'guardian'){
                            val = 'required';
                        }
                        break;
                    case 'mother':
                        if(this.mother_relationship == 'guardian'){
                            val = 'required';
                        }
                        break;
                    default:
                        break;
                }

                return val;
            }
        },
        watch: {
            step() {
                if(this.filled_step < this.step) {
                    this.filled_step = this.step;
                }
                if(this.step>4){
                    clearTimeout(this.expired_reload_func);
                    clearTimeout(this.expired_notification_func);
                }
                if(this.step==1 && _.size(this.opening_years)==0) {
                    this.step = 2;
                }
            },
            year_id() {
                if(_.isNull(this.applicant_data)){
                    this.applying_class = '';
                    this.priority_one = '';
                    this.priority_two = '';
                    this.priority_three = '';
                }
                this.admission_fee = this.fees[this.year_id];
                this.getOpeningInterviews();
            },
            applying_class: function(applying_class) {
                if(this.applicant_data && applying_class==this.applicant_data.applying_class){
                    this.priority_one = this.applicant_data.priority_one;
                    this.priority_two = this.applicant_data.priority_two;
                    this.priority_three = this.applicant_data.priority_three;
                }else{
                    this.priority_one = '';
                    this.priority_two = '';
                    this.priority_three = '';
                }
                this.birth_date_invalid = false;
                if(applying_class){
                    this.sections_length = (this.priority_rank_counts && this.priority_rank_counts[applying_class] != null)
                        ? this.priority_rank_counts[applying_class]
                        : 1;
                }
                _.each(this.level_sections, (value, key) => {
                    if(key==applying_class){
                        this.sections = value;
                    }
                })
            },
            identity_no() {
                clearTimeout(this.birthCertTimeout);
                this.birthCertTimeout = setTimeout(()=>{
                    this.checkBirthCert()
                },1000);
            },
            date_of_birth() {
                clearTimeout(this.birthDateTimeout);
                this.birthDateTimeout = setTimeout(()=>{
                    this.checkBirthDate()
                },1000);
            },
            father_relationship() {
                if(this.father_relationship != 'guardian') {
                    this.father_guardian_relationship = '';
                }
            },
            mother_relationship() {
                if(this.mother_relationship != 'guardian') {
                    this.mother_guardian_relationship = '';
                }
            },
        },
        computed: {
            uploading_files() {
                let result = [];

                _.each(this.upload_files, (files, key) => {
                    _.each(files, (file) => {
                        result.push(file);
                    })
                })

                return result;
            },
            file_infos() {
                let result = {};

                _.each(this.upload_files, (files, key) => {
                    _.each(files, (file) => {
                        result[file] = key;
                    })
                })

                return result;

            },
        },
        mounted() {
            let self = this;
            window.eventHub.$on('paid-admission-fee', (element_id) => {
                this.step++;
            });

            if(this.expired_time!='' && this.expired_time_notification!=''){
                this.expired_notification_popup_timer = (parseInt(this.expired_time) - parseInt(this.expired_time_notification)) * 60 * 1000;
                this.expired_notification_func =setTimeout(this.ReActiveDialog, this.expired_notification_popup_timer); // mins x 1000
                this.expired_reload_func = setTimeout(this.to_index, this.expired_time * 60 * 1000); // mins x 1000
            }

            this.expired_time_for_countdown = this.expired_time * 60 * 1000;
            setTimeout(this.countdown, 1);
        }
    }
</script>
<style>
    .vdatetime-popup__header {
        background : #0cafc2;
    }
    .vdatetime-popup__actions__button {
        color : #0cafc2;
    }

    .vdatetime-calendar__month__day--selected > span > span,
    .vdatetime-calendar__month__day--selected:hover > span > span {
        color: #fff;
        background: #0cafc2;
    }

    .vdatetime-year-picker__item--selected {
        color: #0cafc2;
        font-size: 32px;
    }

    .vdatetime-time-picker__item--selected {
        color: #0cafc2;
        font-size: 32px;
    }

    .modal-dialog.modal-max_modal {
        max-width: 95% !important;
    }

    .modal-open {
        overflow: hidden;
    }

    .modal-open .modal {
        overflow-x: hidden;
        overflow-y: auto;
    }

    .modal {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1050;
        display: none;
        width: 100%;
        height: 100%;
        overflow: hidden;
        outline: 0;
    }

    .modal-dialog {
        position: relative;
        width: auto;
        margin: 0.5rem;
        pointer-events: none;
    }

    .modal.fade .modal-dialog {
        -webkit-transition: -webkit-transform 0.3s ease-out;
        transition: -webkit-transform 0.3s ease-out;
        transition: transform 0.3s ease-out;
        transition: transform 0.3s ease-out, -webkit-transform 0.3s ease-out;
        -webkit-transform: translate(0, -50px);
        transform: translate(0, -50px);
    }

    @media (prefers-reduced-motion: reduce) {
        .modal.fade .modal-dialog {
            -webkit-transition: none;
            transition: none;
        }
    }

    .modal.show .modal-dialog {
        -webkit-transform: none;
        transform: none;
    }

    .modal-dialog-scrollable {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        max-height: calc(100% - 1rem);
    }

    .modal-dialog-scrollable .modal-content {
        max-height: calc(100vh - 1rem);
        overflow: hidden;
    }

    .modal-dialog-scrollable .modal-header,
    .modal-dialog-scrollable .modal-footer {
        -ms-flex-negative: 0;
        flex-shrink: 0;
    }

    .modal-dialog-scrollable .modal-body {
        overflow-y: auto;
    }

    .modal-dialog-centered {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        min-height: calc(100% - 1rem);
    }

    .modal-dialog-centered::before {
        display: block;
        height: calc(100vh - 1rem);
        content: "";
    }

    .modal-dialog-centered.modal-dialog-scrollable {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        height: 100%;
    }

    .modal-dialog-centered.modal-dialog-scrollable .modal-content {
        max-height: none;
    }

    .modal-dialog-centered.modal-dialog-scrollable::before {
        content: none;
    }

    .modal-content {
        position: relative;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        width: 100%;
        pointer-events: auto;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 0.3rem;
        outline: 0;
    }

    .modal-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1040;
        width: 100vw;
        height: 100vh;
        background-color: #000;
    }

    .modal-backdrop.fade {
        opacity: 0;
    }

    .modal-backdrop.show {
        opacity: 0.5;
    }

    .modal-header {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: start;
        -ms-flex-align: start;
        align-items: flex-start;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        padding: 1rem 1rem;
        border-bottom: 1px solid #dee2e6;
        border-top-left-radius: 0.3rem;
        border-top-right-radius: 0.3rem;
        background-color: #0cafc2;
        color: #fff;
    }

    .modal-header .close {
        padding: 1rem 1rem;
        margin: -1rem -1rem -1rem auto;
        color: #fff;
    }

    .modal-title {
        margin-bottom: 0;
        line-height: 1.6;
    }

    .modal-body {
        position: relative;
        -webkit-box-flex: 1;
        -ms-flex: 1 1 auto;
        flex: 1 1 auto;
        padding: 1rem;
    }

    .modal-footer {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: end;
        -ms-flex-pack: end;
        justify-content: flex-end;
        padding: 1rem;
        border-top: 1px solid #dee2e6;
        border-bottom-right-radius: 0.3rem;
        border-bottom-left-radius: 0.3rem;
    }

    .modal-footer > :not(:first-child) {
        margin-left: .25rem;
    }

    .modal-footer > :not(:last-child) {
        margin-right: .25rem;
    }

    .modal-scrollbar-measure {
        position: absolute;
        top: -9999px;
        width: 50px;
        height: 50px;
        overflow: scroll;
    }

    @media (min-width: 576px) {
        .modal-dialog {
            max-width: 500px;
            margin: 1.75rem auto;
        }

        .modal-dialog-scrollable {
            max-height: calc(100% - 3.5rem);
        }

        .modal-dialog-scrollable .modal-content {
            max-height: calc(100vh - 3.5rem);
        }

        .modal-dialog-centered {
            min-height: calc(100% - 3.5rem);
        }

        .modal-dialog-centered::before {
            height: calc(100vh - 3.5rem);
        }

        .modal-sm {
            max-width: 300px;
        }
    }

    @media (min-width: 992px) {
        .modal-lg,
        .modal-xl {
            max-width: 800px;
        }
    }

    @media (min-width: 1200px) {
        .modal-xl {
            max-width: 1140px;
        }
    }

    .close {
        float: right;
        font-size: 1.35rem;
        font-weight: 700;
        line-height: 1;
        color: #000;
        text-shadow: 0 1px 0 #fff;
        opacity: .5;
    }

    .close:hover {
        color: #000;
        text-decoration: none;
    }

    .close:not(:disabled):not(.disabled):hover,
    .close:not(:disabled):not(.disabled):focus {
        opacity: .75;
    }

    button.close {
        padding: 0;
        background-color: transparent;
        border: 0;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Admission/Admission.vue